import isFilledUp from './fields/isFilledUp'
import isEmail from './fields/isEmail'
import isPersonName from './fields/isPersonName'

/** Topics for which the mall dropdown is shown and required (see ShareFeedbackPageForm). */
export const SHARE_FEEDBACK_TOPICS_REQUIRING_MALL = Object.freeze([
  'Cinemas',
  'Offers',
  'Be a Zing Merchant',
  'Explore',
])

const validateFullName = (name, fullName) => {
  if (!isFilledUp(fullName)) {
    return { [name]: 'Full name is required' }
  }
  if (!isPersonName(fullName)) {
    return { [name]: 'Full name contains invalid characters' }
  }
  return {}
}

const validateEmail = (name, email) => {
  if (!isFilledUp(email)) {
    return { [name]: 'Email is required' }
  }
  if (!isEmail(email)) {
    return { [name]: 'Invalid email' }
  }
  return {}
}

const validateTopic = (name, topic) => {
  if (!isFilledUp(topic)) {
    return { [name]: 'Topic is required' }
  }
  return {}
}

const validateMalls = (name, malls, topic) => {
  if (!SHARE_FEEDBACK_TOPICS_REQUIRING_MALL.includes(topic)) {
    return {}
  }
  const filled = Array.isArray(malls) ? malls.length > 0 : isFilledUp(malls)
  if (!filled) {
    return { [name]: 'Mall is required' }
  }
  return {}
}

const validateSubject = (name, subject) => {
  if (!isFilledUp(subject)) {
    return { [name]: 'Subject is required' }
  }
  return {}
}

const validateMessage = (name, message) => {
  if (!isFilledUp(message)) {
    return { [name]: 'Message is required' }
  }
  return {}
}

const validate = values => {
  if (typeof values !== 'object' || values === null) {
    throw new Error(
      'Invalid argument. Validator functions only expect a non-null object.',
    )
  }

  const { name, email, topic, malls, subject, message } = values

  return {
    ...validateFullName('name', name),
    ...validateEmail('email', email),
    ...validateTopic('topic', topic),
    ...validateMalls('malls', malls, topic),
    ...validateSubject('subject', subject),
    ...validateMessage('message', message),
  }
}

export default validate
